export const CONTENT_SET_DATA_TYPES = {
  SENSITIVITY: "SENSITIVITY",
}

export const EXPOSURE_CONSTRAINT_WEIGHTINGS = {
  PERCENT: "PERCENT",
  CURRENCY: "CURRENCY",
}
